/**
 * Descriptions rendered for the same experiment type on both the create-experiment
 * dialog and the start-from-scratch cards. They must read identically on both.
 *
 * Module-level surfaces (e.g. the Get Started test-type picker) describe whole
 * products rather than individual experiment types and intentionally do not
 * source their copy from here.
 */

export const ONSITE_EDITS_DESCRIPTION =
  "Edit or hide page elements like text, images, or sections without changing your theme.";

export const SPLIT_URL_DESCRIPTION =
  "Send visitors to alternate URLs to test page-level changes.";

export const TEMPLATE_DESCRIPTION =
  "Compare and test different homepage, product, and collections templates.";

export const THEME_DESCRIPTION =
  "Test theme redesigns, new navigation, or impact of adding an app.";

export const PRICING_DESCRIPTION =
  "Test price points on one product, multiple products, or entire collections.";

export const SHIPPING_DESCRIPTION =
  "Explore different shipping rates and free shipping thresholds.";

export const OFFER_DESCRIPTION =
  "Compare percentage discounts, dollar-off amounts, or tiered incentives.";

export const CHECKOUT_DESCRIPTION =
  "Try checkout customizations like trust badges, guarantees, and custom images.";
